import { ApplicationConfig } from '@angular/core';
import { applicationConfig } from './app/application.config';
import { mpsConfig } from './mps/mps.config';

export const globalConfig: ApplicationConfig = {
  providers: [...mpsConfig.providers, ...applicationConfig.providers],
};
